

<div class="wallet-container" *ngIf="wallet(); else loadingOrError">
  
    <!-- Display Wallet Balance -->
    <div class="balance">
      <span>Balance:</span>
      <span [ngClass]="{'high': canWithdraw(), 'low': !canWithdraw()}">
        £{{ wallet()!.balance }}
      </span>
    </div>
  
    <!-- Withdrawal Section -->
   @if(!canWithdraw()) {
    <div>
      <p>You need a minimum of &pound;{{wallet()!.minWithdrawalLimit}} to withdraw </p>
    </div>
   }
   @else {
    <div class="withdrawal-section">
      <h5>Withdraw Funds</h5>
      <form>
        <mat-form-field appearance="fill">
          <mat-label>Withdrawal Amount (£)</mat-label>
          <input matInput type="number" [formControl]="withdrawalControl" [max]="+(wallet()!.balance)" />
          <mat-error *ngIf="withdrawalControl.hasError('required')">
            Withdrawal amount is required.
          </mat-error>
          <mat-error *ngIf="withdrawalControl.hasError('min')">
            Minimum withdrawal amount is £1.
          </mat-error>
          <mat-error *ngIf="withdrawalControl.hasError('max')">
            You cannot withdraw more than your balance.
          </mat-error>
        </mat-form-field>
        <div style="text-align: right;">
          <!-- <button mat-raised-button color="primary" (click)="withdraw()" [disabled]="!canWithdraw() || withdrawalControl.invalid || isLoading()">
            {{ isLoading() ? 'Processing...' : 'Withdraw' }}
          </button> -->


          <button mat-raised-button color="primary" [disabled]="true">Withdraw</button>
        </div>
      </form>
  
      <!-- Display Error or Success Messages -->
      <div *ngIf="errorMessage()" class="message">
        {{ errorMessage() }}
      </div>
      <div class="error my-2">
        Wallet transactions are temporarily disabled.
      </div>
    </div>
  }
  </div>
  
  <!-- Loading or Error Template -->
  <ng-template #loadingOrError>
    <div class="loading-error">
      <mat-spinner *ngIf="isLoading()" class="small-spinner"></mat-spinner>
      <div *ngIf="!isLoading() && errorMessage()">
        <p class="error">{{ errorMessage() }}</p>
      </div>
    </div>
  </ng-template>
  